import React from 'react';
import { markerStyles, markerSizes, MarkerIcon, backendToDisplay, displayToBackend } from './MarkerStyles';

const MarkerStyleMenu = ({
  selectedStyle,
  onSelect,
  selectedSize,
  onSizeSelect,
  disabled = false
}) => {
  return (
    <div className="space-y-4">
      {/* Style Selection */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 mb-2">Stil Seçin</h4>
        <div className="grid grid-cols-5 gap-1">
          {markerStyles.map((style) => (
            <button
              key={style.type}
              onClick={() => !disabled && onSelect(style.type)}
              disabled={disabled}
              className={`p-1 border rounded-lg transition-all w-full flex flex-col items-center justify-center gap-0.5 aspect-square ${selectedStyle === style.type
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 hover:border-gray-300'
                } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              title={style.name}
            >
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                {MarkerIcon(style.type, undefined, "xs")}
              </div>
              <span className="text-[8px] font-medium text-gray-700 text-center leading-tight line-clamp-1">
                {style.name}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Size Selection */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 mb-2">Boyut Seçin</h4>
        <div className="grid grid-cols-3 gap-1">
          {Object.entries(markerSizes).map(([size, pixels]) => {
            const displaySize = backendToDisplay(size);
            return (
              <button
                key={size}
                onClick={() => !disabled && onSizeSelect(size)}
                disabled={disabled}
                className={`w-full p-1 border rounded-md text-xs font-medium transition-all flex flex-col justify-center items-center gap-0.5 ${selectedSize === size
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-gray-200 text-gray-600 hover:border-gray-300'
                  } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              >
                <span className="text-sm font-bold">{displaySize}</span>
                <span className="text-[9px] text-gray-400">
                  {pixels}px
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Preview */}
      {selectedStyle && (
        <div className="pt-3 border-t">
          <h4 className="text-sm font-medium text-gray-700 mb-2">Önizleme</h4>
          <div className="flex items-center justify-center p-4 bg-gray-50 rounded-lg">
            {MarkerIcon(selectedStyle, "#ef4444", selectedSize || 'm')}
          </div>
        </div>
      )}
    </div>
  );
};

export default MarkerStyleMenu; 